import { render, staticRenderFns } from "./boardEventStyle.vue?vue&type=template&id=20c6d946&scoped=true&"
import script from "./boardEventStyle.vue?vue&type=script&lang=js&"
export * from "./boardEventStyle.vue?vue&type=script&lang=js&"
import style0 from "./boardEventStyle.vue?vue&type=style&index=0&id=20c6d946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6d946",
  null
  
)

export default component.exports